import React, { useState, useEffect } from "react";
import { Button } from 'primereact/button';
import { Checkbox } from "primereact/checkbox";
import { RadioButton } from "primereact/radiobutton";
import { InputText } from 'primereact/inputtext';
import 'primeicons/primeicons.css';
import Alertas from "../../alertas";

function FinalPedido({ setFraseTopo }) {

    useEffect(() => {
        setFraseTopo("Este é o começo de uma nova jornada.");
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <div className="app-main-mulher">
            <div className="main-card-mulher" style={{ padding: "0px" }}>
                <div className="header-solicitacao-mulher">
                    <h3>SEU PEDIDO DE MEDIDA PROTETIVA FOI REGISTRADO</h3>
                </div>

                <i className="final-icone-mulher pi pi-check-circle"></i>

                <p className="descr-solicitacao-mulher">As suas informações foram recebidas.
                O Núcleo Institucional de Promoção e Defesa dos Direitos  da Mulher irá entrar em contato para dar início ao seu atendimento. </p>
            </div>




            <div className="card-rodape-mulher">
                <Button
                    label="Voltar para o início"
                    className="btn-1-mulher"
                    onClick={() => window.location.reload()}
                />

            </div>
        </div>

    );
}

export default FinalPedido;
